import Vue from 'vue';
import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { ISearch, Search, EnumReservationType, EnumSearchType, IBaseSearch } from '@/models/Search';
import { BrowserStorage } from '@/services/BrowserStorage';

@Module({
    namespaced: true,
    name: 'search',
    store,
    dynamic: true,
})
class SearchStore extends VuexModule {
    public currentSearch: Search = new Search();

    @Action({ commit: 'NEW_SEARCH' })
    public Search(payload: Search | IBaseSearch) {
        BrowserStorage.putSession('search', payload);

        return payload;
    }

    @Action
    public RestoreSearch(): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            const search = BrowserStorage.pullSession('search');

            if (search) {
                await this.context.commit('RESTORE_SEARCH', new Search(search));

                return resolve(true);
            } else {
                reject(false);
            }
        });
    }

    @Mutation
    private UPDATE_SEARCH(payload: Search) {
        this.currentSearch.update(payload);
    }

    @Mutation
    private RESTORE_SEARCH(payload: Search) {
        this.currentSearch = new Search(payload);
    }

    @Mutation
    private NEW_SEARCH(payload: ISearch) {
        this.currentSearch = new Search(payload);
    }
}

export default getModule(SearchStore);
